import PropTypes from 'prop-types'
import { Tag } from 'antd'
import { useMemo, Fragment } from 'react'
import { isCurrentCycle, formatCycleRange } from '../../lib/cycles'
import { useCycles, useFetchCycles } from '../../redux/slices/practices'
import AsyncSelect from './AsyncSelect'

export default function CycleSelect({ practiceId, ...props }) {
  const fetchOptions = useFetchCycles(practiceId)
  const cycles = useCycles(practiceId)
  const options = useMemo(
    () =>
      cycles.map(cycle => {
        const name = formatCycleRange(cycle)

        return {
          value: cycle.id,
          label: (
            <Fragment key={name}>
              {name} {cycle.longPeriod && <Tag color="geekblue">long</Tag>}{' '}
              {isCurrentCycle(cycle) && <Tag color="green">current</Tag>}
            </Fragment>
          ),
        }
      }),
    [cycles],
  )
  return (
    <AsyncSelect
      label="Cycle:"
      fetchOptions={fetchOptions}
      options={options}
      showSearch
      allowClear
      optionFilterProp="children"
      placeholder="Select cycle"
      valuePropName="value"
      labelPropName="label"
      dropdownStyle={{ width: '400px' }}
      filterOption={(input, option) => {
        const cycleName = option.label.key
        return cycleName.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }}
      layout="horizontal"
      {...props}
    />
  )
}

CycleSelect.propTypes = {
  practiceId: PropTypes.string.isRequired,
}
